export const environment = {
  production: true,
  apiUrl: 'https://api.controlcomercioweb.com/'
};
